import { z } from 'zod';

const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters long')
  .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
  .regex(/[a-z]/, 'Password must contain at least one lowercase letter');

const optionalPasswordSchema = z.string().optional().superRefine((value, ctx) => {
  if (!value) return;

  const result = passwordSchema.safeParse(value);
  if (result.success) return;

  for (const issue of result.error.issues) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: issue.message,
    });
  }
});

export const userSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(100),
  email: z.string().email('Invalid email').max(100),
  secret: optionalPasswordSchema,
});
export type UserInput = z.infer<typeof userSchema>;

export const userCreateSchema = userSchema.extend({
  secret: passwordSchema,
});
export type UserCreateInput = z.infer<typeof userCreateSchema>;
